(function ($) {
    $(document).ready(function () {  
        /**
         * Search
         */
        if($('#Search__Input').length) {
            $('a[href="/search"]').on('click', function (e) {
                e.preventDefault();
                if($(this).hasClass('active')) {
                    $('a[href="/search"]').removeClass('active');
                } else {
                    $('a[href="/search"]').addClass('active');
                }
                $('.hp_header').addClass('search_open');
                setTimeout(() => {
                $('.PageOverlay').removeClass('is-visible');
                if($('#Search').attr('aria-hidden') == 'false') {
                    $('#Search').attr('aria-hidden', true);
                    document.getElementById("Search__Input").value = "";
                } else {
                    $('#Search').attr('aria-hidden', false);
                    $('#Search').attr('tabindex', '-1');
                }
                var myElement = $('#shopify-section-header');
                myElement.css('z-index', 100);
                }, 10);
            });

            $('.Search__Close').on('click', function (e) {
                document.getElementById("Search__Form").reset();
            });

            const sinp = document.querySelector('#Search__Input');
            sinp.addEventListener('input', evt => {  // Validate input
                const value = sinp.value.trim();

                if (value.length > 0) {
                    $('.search_sug_menu').hide();
                    $('.button-search-form').addClass('active');
                } else {
                    $('.search_sug_menu').show();
                    $('.button-search-form').removeClass('active');
                }
            });

            if(document.getElementById("Search__Input").value.length>0) {
                $('.button-search-form').addClass('active');
            } else {
                $('.button-search-form').removeClass('active');
            }

            $('.close_search').on('click', function (e) {
                $('a[href="/search"]').removeClass('active');
                $('#Search').attr('aria-hidden', 'true');
                //Search__Input
                document.getElementById("Search__Input").value = "";
            });
            
            $('#Search').on('click', '.section_bg', function () {
                $('a[href="/search"]').removeClass('active');
                document.getElementById("Search__Input").value = "";
                $(this).parent('#Search').attr('aria-hidden', 'true');
            });
        }

        const filterBtn = document.querySelectorAll('.search_results .sort_filt .single_filter input[type="radio"]');
        if (filterBtn) {
            for (const radio of filterBtn) {
            if (radio.checked) var radioValue = radio.value;
            radio.addEventListener('change', () => {
                radioValue = radio.value;
                if (radioValue == 'search_product') {
                    document.querySelector('.search_results .product_search_wrap').style.display = 'block';
                    document.querySelector('.search_results .article_search_wrap').style.display = 'none';
                    document.querySelector('.search_results .page_search_wrap').style.display = 'none';
                } else if (radioValue == 'search_article') {
                    document.querySelector('.search_results .product_search_wrap').style.display = 'none';
                    document.querySelector('.search_results .article_search_wrap').style.display = 'block';
                    document.querySelector('.search_results .page_search_wrap').style.display = 'none';
                } else if (radioValue == 'search_page') {
                    document.querySelector('.search_results .product_search_wrap');
                    document.querySelector('.search_results .article_search_wrap').style.display = 'none';
                    document.querySelector('.search_results .page_search_wrap').style.display = 'block';
                } else {
                    document.querySelector('.search_results .product_search_wrap').style.display = 'block';
                    document.querySelector('.search_results .article_search_wrap').style.display = 'block';
                    document.querySelector('.search_results .page_search_wrap').style.display = 'block';
                }
            });
            }
        }

        const product_search_wrap = document.querySelectorAll('.search_results .product_search_wrap');
        const product_search = document.querySelectorAll('.search_results .product_search_wrap .single_product');
        if (product_search_wrap) {
            if (product_search.length > 3) {
            $('.search_results .product_search_wrap .swh_showmore').show();
            }
            $('.search_results .product_search_wrap .swh_showmore').click(function () {
            $('.search_results .product_search_wrap .single_product').show();
            })
        }

        const article_search_wrap = document.querySelectorAll('.search_results .article_search_wrap');
        const article_search = document.querySelectorAll('.search_results .article_search_wrap .ArticleItem');
        if (article_search_wrap) {
            if (article_search.length > 3) {
            $('.search_results .article_search_wrap .swh_showmore').show();
            }
            $('.search_results .article_search_wrap .swh_showmore').click(function () {
            $('.search_results .article_search_wrap .ArticleItem').show();
            })
        }

        const page_search_wrap = document.querySelectorAll('.search_results .page_search_wrap');
        const page_search = document.querySelectorAll('.search_results .page_search_wrap .ArticleItem');
        if (page_search_wrap) {
            if (page_search.length > 3) {
            $('.search_results .page_search_wrap .swh_showmore').show();
            }
            $('.search_results .page_search_wrap .swh_showmore').click('.swh_showmore', function () {
            $('.search_results .page_search_wrap .ArticleItem').show();
            })
        }

        function sortProducts(product_search, article_search, page_search, selectedSortCriteria = 'name', sortOrder = 'a_z') {
            const sortCriteria = {
            name: (a, b) =>
                sortOrder === 'a_z'
                ? a.dataset.name.localeCompare(b.dataset.name)
                : b.dataset.name.localeCompare(a.dataset.name),
            date: (a, b) =>
                sortOrder === 'date_desc'
                ? new Date(b.dataset.date) - new Date(a.dataset.date)
                : new Date(a.dataset.date) - new Date(b.dataset.date),
            };
            const sortedProducts = product_search.sort(sortCriteria[selectedSortCriteria]);
            sortedProducts.forEach((product_search, index) => {
            product_search.style.order = index.toString();
            if (index < 3) {
                product_search.style.display = 'block';
            } else {
                product_search.style.display = 'none'
            }
            });

            const sortedArticles = article_search.sort(sortCriteria[selectedSortCriteria]);
            sortedArticles.forEach((article_search, index) => {
            article_search.style.order = index.toString();
            if (index < 3) {
                article_search.style.display = 'block';
            } else {
                article_search.style.display = 'none'
            }
            });
            const sortedPages = page_search.sort(sortCriteria[selectedSortCriteria]);
            sortedPages.forEach((page_search, index) => {
            page_search.style.order = index.toString();
            if (index < 3) {
                page_search.style.display = 'block';
            } else {
                page_search.style.display = 'none'
            }
            });


        }
        
        const SortSearch = document.querySelector('#SortSearch');
        if (SortSearch) {
          NiceSelect.bind(SortSearch, { searchable: false, placeholder: 'Sort' });
        }
        function sortProductsInit(product_search, article_search, page_search) {
            const sortedProducts = Array.from(product_search);
            const sortedArticles = Array.from(article_search);
            const sortedPages = Array.from(page_search);
            const sortSelect = document.querySelector('#SortSearch');
            if (sortSelect) {
            sortSelect.addEventListener('change', () => {
                let selectedSortCriteria = 'name';
                if (sortSelect.value === 'date_asc' || sortSelect.value === 'date_desc')
                selectedSortCriteria = 'date';
                sortProducts(sortedProducts, sortedArticles, sortedPages, selectedSortCriteria, sortSelect.value);
            });
            }
        }
        sortProductsInit(product_search, article_search, page_search);

        /**
         * blog tags
         */
        if(document.querySelector('.blog_sort_filt') && document.querySelector('.breadcrumbs .current_blog_tag')){
            let blog_tag_name = document.querySelector('.blog_sort_filt .Blog__TagList .Heading.is-active');
            document.querySelector('.breadcrumbs .current_blog_tag').innerText = blog_tag_name.textContent;
        }
    });
})(jQuery);